import { RootState } from '@global/store/store';

export const userSelector = (state: RootState) => state.user.user;
